(function () {
	'use strict';

	angular.module('DcDepotModule').config(stateConfig);

	stateConfig.$inject = ['$stateProvider'];

	function stateConfig($stateProvider) {
		$stateProvider.state('depot-parent', {
			url: '/depot',
			parent: 'target-project',
			abstract: true,
		});

		$stateProvider.state('depots', {
			url: '/list',
			parent: 'depot-parent',
			data: {
				admin: true,
				access: 'member',
				title: 'Dépôts',
			},
			views: {
				'@depot-parent': {
					template: `<app-depot-list ng-prop-project_label="$ctrl.projectLabel"></app-depot-list>`,
					controller: [
						'AppSelectorService',
						function (AppSelectorService) {
							const $ctrl = this;
							init();
							function init() {
								$ctrl.projectLabel =
									AppSelectorService.getSelectedProjectLabel();
							}
						},
					],
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('depots-new-v2-with-modal', {
			url: '/create',
			parent: 'depot-parent',
			data: {
				admin: true,
				access: '*',
				title: 'Nouveau Dépôt',
			},
			views: {
				'@depot-parent': {
					controller: [
						'$timeout',
						'NgDepot',
						function ($timeout, NgDepot) {
							$timeout(function () {
								NgDepot.openCreateDepotModal();
							}, 16);
						},
					],
				},
			},
		});

		$stateProvider.state('depots-new', {
			url: '/new',
			parent: 'depot-parent',
			data: {
				admin: true,
				access: 'member',
				title: 'Nouveau Dépôt',
			},
			params: {
				dataFromPreviousState: {
					value: null,
					squash: true,
					dynamic: true,
				},
			},
			resolve: {
				passedData: [
					'$stateParams',
					function ($stateParams) {
						return $stateParams.dataFromPreviousState;
					},
				],
			},
			views: {
				'@depot-parent': {
					templateUrl: './src/components/modules/depot/depot-form.html',
					controller: 'DepotEditController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('depots-edit', {
			url: '/edit/:type/:id',
			parent: 'depot-parent',
			data: {
				admin: true,
				access: 'member',
				title: 'Edition du Dépôt',
			},
			resolve: {
				passedData: [
					function () {
						return null;
					},
				],
			},
			views: {
				'@depot-parent': {
					templateUrl: './src/components/modules/depot/depot-form.html',
					controller: 'DepotEditController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('depots-fromConnector', {
			url: '/new/fromConnector/:connectorId',
			parent: 'depot-parent',
			data: {
				admin: true,
				access: 'member',
				title: "Dépôt à partir d'un Connecteur",
			},
			resolve: {
				passedData: [
					function () {
						return null;
					},
				],
			},
			views: {
				'@depot-parent': {
					templateUrl: './src/components/modules/depot/depot-form.html',
					controller: 'DepotEditController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('depots-duplicate', {
			url: '/:type/duplicate/:duplicatedId',
			parent: 'depot-parent',
			data: {
				admin: true,
				access: 'member',
				title: 'Dupliquer le Dépôt',
			},
			resolve: {
				passedData: [
					function () {
						return null;
					},
				],
			},
			views: {
				'@depot-parent': {
					templateUrl: './src/components/modules/depot/depot-form.html',
					controller: 'DepotEditController',
					controllerAs: '$ctrl',
				},
			},
		});

		$stateProvider.state('old-depots', {
			url: '',
			parent: 'depot-parent',
			data: {
				admin: true,
				access: 'member',
				title: 'Dépôts',
			},
			views: {
				'@depot-parent': {
					templateUrl: './src/components/modules/depot/depots.html',
					controller: 'DepotListController',
					controllerAs: '$ctrl',
				},
			},
		});
	}
})();
